import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Button } from '@ui/components/Button'

import { useScrollToTop } from '@hooks/useScrollToTop'

import {
  StatusTemplateBody,
  StatusTemplateButtons,
  StatusTemplateWrapper,
} from '@shared/templates/StatusTemplate/StatusTemplate'

export const BlockedPage: React.FC = () => {
  useScrollToTop()
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <StatusTemplateWrapper>
      <StatusTemplateBody
        title={t('Sign up.Your registration has been unsuccessful') + '!'}
        text={[
          t('Sign up.From the information you have provided, we do not think', {
            email: 'support@tickmill.co.uk',
          }),
        ]}
        icon={'Fail'}
      />
      <StatusTemplateButtons>
        <Button.Primary size='lg' fullWidth onClick={() => navigate('/')}>
          {t('Close')}
        </Button.Primary>
      </StatusTemplateButtons>
    </StatusTemplateWrapper>
  )
}
